import { render, staticRenderFns } from "./QualificationRequirementSummary.vue?vue&type=template&id=685ecbc8"
import script from "./QualificationRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./QualificationRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports